export default "__VITE_PUBLIC_ASSET__42c54ad4__"